import * as _ from 'lodash';
import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

@Pipe({
    name: 'dataFilter'
})
export class DataFilterPipe implements PipeTransform {
 constructor(private _localStorage: LocalStorageService,) {}
    transform(array: any[], query: string, filterType: string ): any {
        if( filterType == 'labor' ) {
            if (query) {
                
                this._localStorage.store('export_data', _.filter(array, row=>
                    row.id_labor.toLowerCase().indexOf(query.toLowerCase()) > -1 || 
                    row.id_usuario.toLowerCase().indexOf(query.toLowerCase()) > -1|| 
                    row.campo_lote.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                    row.localidad.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                    row.coordinador.toLowerCase().indexOf(query.toLowerCase()) > -1));

                return _.filter(array, row=>
                    row.id_labor.toLowerCase().indexOf(query.toLowerCase()) > -1 || 
                    row.id_usuario.toLowerCase().indexOf(query.toLowerCase()) > -1|| 
                    row.campo_lote.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                    row.localidad.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
                    row.coordinador.toLowerCase().indexOf(query.toLowerCase()) > -1);
            }
        }
        else {
            if (query) {
                this._localStorage.store('export_data', _.filter(array, row=>row.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1 || row.apellido.toLowerCase().indexOf(query.toLowerCase()) > -1|| row.dni.toLowerCase().indexOf(query.toLowerCase()) > -1));
                return _.filter(array, row=>row.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1 || row.apellido.toLowerCase().indexOf(query.toLowerCase()) > -1|| row.dni.toLowerCase().indexOf(query.toLowerCase()) > -1);
            }
        }
        return array;
    }

    private search(row, query):boolean{    
        query = query.toLowerCase();
    	for(var index in row){
            var data = index=='activo' ?
                        (row[index]?'Activo':'Inactivo')
                      : (index=='tipo_pregunta' ?
                        this.getQuestionType(row[index])
                      : (index=='tipo_auditor' ?
                        this.getAuditorType(row[index])
                      : (index=='porcentaje_avance' ?
                        row[index]+'%'
                      : (index=='fecha_desde' ?
                        moment(moment(row[index].replace("Z","-03:00"), 'YYYY-MM-DD HH:mm:ssZZ').utc().tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                      : row[index]))));
            if((data+"").toLowerCase().indexOf(query) > -1)
            	return true;
        }
        return false;
    }

    private getQuestionType(type:number){
        switch(type){
            case 1:
                return 'TEXTO';
            case 2:
                return 'NUMERO';
            case 3:
                return 'SELECCION';
            case 4:
                return 'FOTO';
            default:
                return 'SI/NO';
        }
    }

    private getAuditorType(type:number){
        switch(type){
            case 1:
                return 'VENDEDOR';
            default:
                return 'AUDITOR';
        }
    }
}


// WEBPACK FOOTER //
// /app/src/app/theme/pipes/dataFilter/data-filter.pipe.ts